
// This is an auto generated file - do not edit!
// Swagger path: /api/ClientProductAllocation/{id}/permissions

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    EntityPermissionType
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class ClientproductallocationIdPermissionsApiService extends BaseApiService {
    
    get(id: string, options = {}): Observable<EntityPermissionType[]> {
        return this._get<EntityPermissionType[]>(
            `/ClientProductAllocation/${id}/permissions`,
            options
        );
    }
}
